export default __webpack_public_path__ + "static/betql-image-right-1-mobile-c6629b44be9b336df2298178ecc50acb.webp";